import LABELS from './labels';
import {
  normalizeCnpjForStorage,
  isNumericCnpjValid
} from '../../../../../../legacy/js/formatters/cnpj-dual';

const ALPHANUMERIC_BODY_PATTERN = /^[A-Z0-9]{12}[0-9]{2}$/;

const validateCnpj = isEditPage => cnpj => {
  if (!cnpj) {
    return isEditPage ? undefined : LABELS.VALIDATION_MESSAGES.REQUIRED;
  }

  const normalized = normalizeCnpjForStorage(cnpj);

  if (normalized.length !== 14) {
    return LABELS.VALIDATION_MESSAGES.CNPJ_INVALID_LENGTH;
  }

  if (!/^[A-Z0-9]{14}$/.test(normalized)) {
    return LABELS.VALIDATION_MESSAGES.INVALID_CNPJ_GENERIC;
  }

  if (/^[0-9]{14}$/.test(normalized)) {
    if (!isNumericCnpjValid(normalized)) {
      return LABELS.VALIDATION_MESSAGES.INVALID_CNPJ;
    }
    return undefined;
  }

  if (ALPHANUMERIC_BODY_PATTERN.test(normalized)) {
    return undefined;
  }

  return LABELS.VALIDATION_MESSAGES.INVALID_CNPJ_GENERIC;
};

export default validateCnpj;
